export const SALE_ORDER = 'SaleOrder'
export const RETURN = 'Returns'
